import { render, staticRenderFns } from "./EditableCellCategory.vue?vue&type=template&id=2fe5a6bc"
import script from "./EditableCellCategory.vue?vue&type=script&lang=ts"
export * from "./EditableCellCategory.vue?vue&type=script&lang=ts"
import style0 from "./EditableCellCategory.vue?vue&type=style&index=0&id=2fe5a6bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports